module.exports = __webpack_public_path__ + "img/carousel-2.d067086b.png";